var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var SendEmailWorkflowBlock = /** @class */ (function (_super) {
            __extends(SendEmailWorkflowBlock, _super);
            function SendEmailWorkflowBlock(id, label) {
                var _this = _super.call(this, id, 8 /* SendEmailAction */, label) || this;
                _this.svgScale = 0.75;
                _this.svgToolbarScale = 0.4;
                _this.svgWidth = 116;
                _this.svgHeight = 76.7;
                _this.svgUrl = "./Content/Images/WorkflowShapes/SendEmail.svg";
                _this.svgAttributes = { id: _this.id, "data-class": "workflowBlock", "data-id": "sendEmail" };
                return _this;
            }
            SendEmailWorkflowBlock.prototype.populateDto = function (dto) {
                this.sendEmailDto = dto;
            };
            return SendEmailWorkflowBlock;
        }(models.SingleOutputWorkflowBlock));
        models.SendEmailWorkflowBlock = SendEmailWorkflowBlock;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
